import { LuneTheme } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import Image from 'next/image'
import { FC, ReactNode } from 'react'

import { difference } from '@/components/EtsMap/utils'

import '@fontsource/space-mono'
import '@fontsource/space-grotesk'

import '@fontsource/space-mono/400.css'
import '@fontsource/space-grotesk/700.css'

export const mobileCards: MobileMapLegendBoxProps[] = [
    {
        header: (
            <>
                Asia to Mediterranean
                <br />1 TEU, CMA CGM Galapagos
            </>
        ),
        name: 'CGA CGM Galapagos',
        logo: '/images/carrier-logos/carrier-cma-cgm.png',
        surcharge: '23.00',
        luneEstimate: '18.57',
    },
    {
        header: (
            <>
                Europe to North America
                <br />1 TEU, MSC Branka
            </>
        ),
        name: 'MSC Branka',
        logo: '/images/carrier-logos/carrier-msc.png',
        surcharge: '35.00',
        luneEstimate: '17.88',
    },
    {
        header: (
            <>
                Intra-Mediterranean
                <br />1 TEU, HAPAG-LLOYD Ludwigshafen Express
            </>
        ),
        name: 'HAPAG-LLOYD Ludwigshafen Express',
        logo: '/images/carrier-logos/carrier-hapag-lloyds.png',
        surcharge: '14.00',
        luneEstimate: '4.76',
    },
]

export interface MobileMapLegendBoxProps {
    header: ReactNode
    name: string
    logo: string
    surcharge: string
    luneEstimate: string
}

const T: FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <Text
            color={`Blue500`}
            sx={{
                fontFeatureSettings: `'liga' off`,
                fontFamily: 'Space Mono',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '120%',
            }}
        >
            {children}
        </Text>
    )
}

const MobileMapLegendBox: FC<MobileMapLegendBoxProps> = ({
    header,
    name,
    logo,
    surcharge,
    luneEstimate,
}) => {
    const { palette } = LuneTheme

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                fontFamily: 'Space Grotesk',
                p: 3,
                backgroundColor: `white`,
                color: palette.Blue500,
                border: '1px solid',
                borderColor: palette.Blue500,
                borderRadius: '24px',
                width: '100%',
                gap: 2,
                fontSize: '14px',
                height: '100%',
                svg: {
                    width: '16px',
                },
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                <Text
                    color={`Blue500`}
                    sx={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        fontFamily: 'Space Grotesk',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: '140%',
                    }}
                >
                    {header}
                </Text>
                <Image alt={name} src={logo} width={32} height={32} />
            </Box>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    justifyContent: 'center',
                    gap: 1,
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                    }}
                >
                    <T>Carrier surcharge</T>
                    <T>&euro; {surcharge}</T>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                    }}
                >
                    <T>Lune estimate</T>
                    <T>&euro; {luneEstimate}</T>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                    }}
                >
                    <T>Difference</T>
                    <T>{difference(surcharge, luneEstimate)} %</T>
                </Box>
            </Box>
        </Box>
    )
}

export default MobileMapLegendBox
